/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import CheckTwoToneIcon from "@mui/icons-material/CheckTwoTone";
import { Box, Button, Typography, useTheme } from "__barrel_optimize__?names=Box,Button,Typography,useTheme!=!@mui/material";
import { useParams } from "next/navigation";
import { useTranslation } from "../../../i18n/client";
import { tokens } from "../../application/theme";
import { FREE_PLAN } from "./plans";
export default function PricingCard(param) {
    let { plan, isPopular, isCurrentPlan, onClick } = param;
    const params = useParams();
    const { t } = useTranslation(params ? params.lng : "en", "pricing-page");
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isFreePlan = plan.planName === FREE_PLAN;
    return /*#__PURE__*/ _jsxs(Box, {
        sx: {
            display: "flex",
            flexDirection: "column",
            width: "280px",
            borderRadius: "12px",
            background: "#fff",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
            padding: "20px",
            position: "relative"
        },
        children: [
            isPopular && /*#__PURE__*/ _jsx(Box, {
                sx: {
                    position: "absolute",
                    top: "-10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    background: "#CFA0FF",
                    padding: "4px 12px",
                    borderRadius: "8px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#fff"
                },
                children: t("MOST POPULAR")
            }),
            /*#__PURE__*/ _jsx(Typography, {
                sx: {
                    fontSize: "20px",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingBottom: "12px"
                },
                children: t(plan.planName)
            }),
            /*#__PURE__*/ _jsxs(Typography, {
                sx: {
                    fontSize: "30px",
                    fontWeight: "600",
                    textAlign: "center",
                    paddingBottom: "10px"
                },
                children: [
                    plan.price,
                    !isFreePlan && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            " ",
                            /*#__PURE__*/ _jsx(Typography, {
                                component: "span",
                                sx: {
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    color: "gray"
                                },
                                children: t("tax")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Typography, {
                sx: {
                    fontSize: "14px",
                    fontWeight: "500",
                    textAlign: "center",
                    color: "gray",
                    paddingBottom: "20px"
                },
                children: [
                    t(plan.duration),
                    "*"
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                fullWidth: true,
                disabled: isCurrentPlan,
                sx: {
                    background: colors.button.main,
                    borderRadius: "10px",
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "12px",
                    "&:hover": {
                        background: colors.button.mainOnHower
                    },
                    "&.Mui-disabled": {
                        background: colors.button.main,
                        color: "#fff",
                        opacity: 0.6
                    }
                },
                onClick: ()=>onClick(plan),
                children: isCurrentPlan ? t("Current Plan") : isFreePlan ? t("tryFreePlan") : t("buyPlan")
            }),
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    marginTop: "20px"
                },
                children: plan.features.map((feature)=>/*#__PURE__*/ _jsxs(Box, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            paddingBottom: "10px"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(CheckTwoToneIcon, {
                                sx: {
                                    fontSize: "medium"
                                }
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                sx: {
                                    fontSize: "14px"
                                },
                                children: t(feature)
                            })
                        ]
                    }, feature))
            })
        ]
    });
}
